import { render, staticRenderFns } from "./AlertNotResult.vue?vue&type=template&id=499329af&"
import script from "./AlertNotResult.vue?vue&type=script&lang=js&"
export * from "./AlertNotResult.vue?vue&type=script&lang=js&"
import style0 from "./AlertNotResult.vue?vue&type=style&index=0&id=499329af&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports